import { render, staticRenderFns } from "./SchoolActivityVideo.vue?vue&type=template&id=59fe99fa"
import script from "./SchoolActivityVideo.vue?vue&type=script&lang=js"
export * from "./SchoolActivityVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59fe99fa')) {
      api.createRecord('59fe99fa', component.options)
    } else {
      api.reload('59fe99fa', component.options)
    }
    module.hot.accept("./SchoolActivityVideo.vue?vue&type=template&id=59fe99fa", function () {
      api.rerender('59fe99fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/schoolHomeCommunication/modules/SchoolActivityVideo.vue"
export default component.exports